import { Typography, Box, useTheme, Stack, IconButton, Card, Divider } from "@mui/material";
import ArrowBack from '@mui/icons-material/ArrowBack';
import Close from '@mui/icons-material/Close';

import { tokens } from "../theme/theme";
const ReportsHeader = ({ title, subtitle, callback }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const call_backprocess = () => {
    callback();
  }

  return (
    <Box >
      
      <Box sx={{ padding: "2px", marginLeft: "5px"  }} display="flex" justifyContent="space-between" alignItems="center">
        <Box marginTop={0} display="flex">
          <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >
            {title}
          </Typography>
          <Typography variant="h5" color={colors.greenAccent[400]}>
            {subtitle}
          </Typography>
        </Box>

        <div>
          <IconButton onClick={call_backprocess} >
            <Close  style={{ fontSize:"18px", color: "white" }} />
          </IconButton>
        </div>
      </Box>
    </Box>

  );
};

export default ReportsHeader;




